export default "__VITE_ASSET__DNRCmhMe__"